import React, { useEffect, useState } from "react";
// import "./Tooltip.css";

const Tooltip = (props) => {
    let timeout, closeTimeout;
    const [active, setActive] = useState(false);

    const showTip = () => {
        if (!active) {
            setActive(true)
        }
    };

    // useEffect(() => {
    //     if (sessionStorage.getItem("channel") === "OEMAPS1") {
    //       //   import('./TransactionSummaryOEM.css');
    //       console.log("came into OEMAPS1")
    //       import('./ToolTipOEM.css');
    //     } else {
    //       console.log("came into APS")
    //       import('./Tooltip.css');
    //     }
    //   }, [])

    useEffect(() => {
        if (!active){
            clearInterval(closeTimeout)
        }
        if (active) {
            closeTimeout = setTimeout(() => {
                setActive(false);
            }, 3000)
        }
        return () => {
            clearInterval(closeTimeout)
        }
    }, [active])

    useEffect(() => {
        if (props.initialShow === true) {
            showTip()
        }
    }, [])

    // console.log(props.content,'siddd')

    return (
        <div
            className="Tooltip-Wrapper"
            onTouchStart={() => props.redeemEducate === true ? null : showTip()}
           onMouseLeave={() => {setActive(false);clearInterval(closeTimeout)}}
            style={{ marginLeft: '5px' }}
        >
            {/* Wrapping */}
            {props.children}
            {active && (
                <div style={{ display: 'flex', alignItems: 'center' }} className={props.pending ? `pending-tooltip ${props.direction || "top"}` : props.redeem ? `redeem-acepoints-tooltip ${props.direction || "top"}` : props.redeemEducate ? `redeemEducate ${props.direction || "top"}` : props.redeemAcePoints?'redeem-ace-points-info': props.redeemProcessingFee ? 'redeem-processing-fee-info':props.smartRedeemFee ? `redeem-processing-fee-info1 ${props.direction || "top"}` : `Tooltip-Tip ${props.direction || "top"}`} >
                  
                    {props.content}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
